module.exports = __webpack_public_path__ + "img/LOGO-GPSCHILE-BLANCO-20180306.1e8eaa03.png";